var _path, _path2, _circle, _circle2, _circle3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgVideoCall = function SvgVideoCall(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 512,
    height: 512,
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.75 24h-9.5C1.01 24 0 22.99 0 21.75v-7.5C0 13.01 1.01 12 2.25 12h9.5c1.24 0 2.25 1.01 2.25 2.25v7.5c0 1.24-1.01 2.25-2.25 2.25m-9.5-10.5a.75.75 0 0 0-.75.75v7.5c0 .413.337.75.75.75h9.5c.413 0 .75-.337.75-.75v-7.5a.75.75 0 0 0-.75-.75z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.25 23.5a.7.7 0 0 1-.308-.066l-5-2.25a.749.749 0 1 1 .615-1.367L17.5 21.59v-7.18l-3.942 1.773a.75.75 0 1 1-.615-1.367l5-2.25A.746.746 0 0 1 19 13.25v9.5a.75.75 0 0 1-.75.75M15.75 11a.747.747 0 0 1-.75-.75V8h-1.25C12.785 8 12 7.215 12 6.25v-4.5C12 .785 12.785 0 13.75 0h8.5C23.215 0 24 .785 24 1.75v4.5C24 7.215 23.215 8 22.25 8h-3.42l-2.527 2.757a.75.75 0 0 1-.553.243m-2-9.5a.25.25 0 0 0-.25.25v4.5c0 .138.112.25.25.25h2a.75.75 0 0 1 .75.75v1.072l1.447-1.579A.75.75 0 0 1 18.5 6.5h3.75a.25.25 0 0 0 .25-.25v-4.5a.25.25 0 0 0-.25-.25z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 3.998,
    r: 0.75
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 15.506,
    cy: 3.998,
    r: 0.75
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 20.494,
    cy: 3.998,
    r: 0.75
  })));
};
export default SvgVideoCall;